import "./Latency.scss";

import { formatMilliseconds } from "../../../../utils/NumbersFormatting";

interface LatencyProps {
  latency: number | null;
}

const Latency: React.FC<LatencyProps> = ({ latency }) => {
  return latency ? (
    <div className="playground-latency">
      Latency:&nbsp;
      <span
        className={`playground-latency-${latency < 1000 ? "success" : "error"}`}
      >
        {formatMilliseconds(Math.round(Math.max(latency * 1000, 1)))}
      </span>
    </div>
  ) : null;
};

export { Latency };
